import { iCaseComponentsResultItem, tBlenderCaseModel, tCaseComponentType } from '@/Interfaces/caseComponentsLib';
import { caseComponentsLib } from '@/Constants/caseComponentsLib/caseComponentsLib';
import { mapTypeToHoles } from '@/Constants/holes';
import { Part } from '@/Engine/Part';
import { mapAccessoryToHoles } from '@/Constants/accessoryHoles';

export function getPositionYFromHoles(item: iCaseComponentsResultItem, toolChestName?: tBlenderCaseModel) {
    const positionZero = 0;
    const currentCaseComponent = caseComponentsLib.find(component => component.id === item.prototypeId);
    if (!currentCaseComponent || item.indexPositionY === undefined) return positionZero;

    let holes;
    if (currentCaseComponent.type === 'accessory') {
        if (mapAccessoryToHoles[currentCaseComponent.blenderName] === undefined ||
            mapAccessoryToHoles[currentCaseComponent.blenderName][toolChestName] === undefined) {
            console.warn('Не найден массив отверстий для аксессуара');
            return positionZero;
        }
        holes = mapAccessoryToHoles[currentCaseComponent.blenderName][toolChestName]?.y;
    } else {
        if (mapTypeToHoles[currentCaseComponent.blenderName] === undefined ||
            mapTypeToHoles[currentCaseComponent.blenderName][toolChestName] === undefined) {
            console.warn('Не найден массив отверстий для комплектующего');
            return positionZero;
        }
        holes = mapTypeToHoles[currentCaseComponent.blenderName][toolChestName];
    }


    // console.log('!!!!!!!', holes, holes[item.indexPositionY], item.indexPositionY);
    if (holes[item.indexPositionY] === undefined) {
        console.error(`Индекс indexPositionY=${item.indexPositionY} превышает размер массива`);
        return positionZero;
    }
    return holes[item.indexPositionY];
}
export function getPositionXFromHoles(item: iCaseComponentsResultItem, toolChestName?: tBlenderCaseModel) {
    const positionZero = 0;
    const currentCaseComponent = caseComponentsLib.find(component => component.id === item.prototypeId);
    if (!currentCaseComponent || item.indexPositionX === undefined) return positionZero;

    if (currentCaseComponent.type !== 'accessory') return positionZero;
    if (
        mapAccessoryToHoles[currentCaseComponent.blenderName] === undefined ||
        mapAccessoryToHoles[currentCaseComponent.blenderName][toolChestName] === undefined
    ) {
        console.error('Не найден массив отверстий для аксессуара');
        return positionZero;
    }

    const holes = mapAccessoryToHoles[currentCaseComponent.blenderName][toolChestName]?.x;

    // console.log('!!!!!!!', holes, holes[item.indexPositionX], item.indexPositionX);
    if (holes[item.indexPositionX] === undefined) {
        console.error(`Индекс indexPositionX=${item.indexPositionX} превышает размер массива`);
        return positionZero;
    }
    return holes[item.indexPositionX];
}


export function getPositionYByIndexHoles(part: Part, toolChestBlenderName?: string | undefined) {
    const caseComponent =  part.raw;
    if (!caseComponent) {
        console.error('Не найдено caseComponent');
        return;
    }
    if (!toolChestBlenderName) {
        console.error('undefined blenderName toolChest');
        return;
    }
    return getPositionYFromHoles(caseComponent, toolChestBlenderName);
}
export function getPositionXByIndexHoles(part: Part, toolChestBlenderName?: string | undefined) {
    const caseComponent =  part.raw;
    if (!caseComponent) {
        console.error('Не найдено caseComponent');
        return;
    }
    if (!toolChestBlenderName) {
        console.error('undefined blenderName toolChest');
        return;
    }
    return getPositionXFromHoles(caseComponent, toolChestBlenderName);
}